import React, { useEffect, useState } from "react";
import { Button, LoadingOverlay } from "@mantine/core";
import {
  getFirestore,
  collection,
  addDoc,
  Timestamp,
  getDocs,
  query,
  where,
  updateDoc,
  doc,
  getDoc,
} from "firebase/firestore";
import { showNotification } from "@mantine/notifications";
import { app, db, functions } from "../../firebase/FirebaseCredential";
import { logError } from "../ErrorLogService/ErrorLoggingService";
import { useUserContext } from "../../contextapi/UserContext";
import { useAppSelector } from "../../hooks/hooks";
import { RootState } from "../../store/store";
import { toast } from "react-toastify";
import { showToast } from "../Utils/toastHelper";
import { getFunctions, httpsCallable } from "firebase/functions";

// Define the type for location data structure
interface LocationData {
  latitude: number;
  longitude: number;
}

// Define the document structure for Firestore attendance entries
interface AttendanceEntry {
  userId: string;
  companyId: string;
  checkInTime?: Date;
  checkOutTime?: Date;
  location?: LocationData;
  status: "checked-in" | "checked-out";
}

const SimpleRemoteCheckFeature: React.FC<any> = ({ }) => {
  const [isCheckedIn, setIsCheckedIn] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const { profileDetails, roleDetails } = useUserContext();
  const companyId = useAppSelector(
    (state: RootState) => state.session?.company_id
  );
  // console.log(profileDetails, "profileDetails");
  const getfunctionlocation = getFunctions(app, 'asia-south1');



  useEffect(() => {
    if (profileDetails?.uid) {
      checkAdminCheckin();
    }
  }, [profileDetails?.uid]);
  // const handleCheckIn = async () => {
  //   if (!companyId) {
  //     console.error("Company ID is null or undefined.");
  //     return;
  //   }

  //   try {
  //     setLoading(true);
  //     const currentTime = Timestamp.fromDate(new Date());
  //     const attendanceHistoryRef = collection(db, "attendancehistory");
  //     let userIp = "";

  //     try {
  //       const ipResponse = await fetch("https://api64.ipify.org?format=json");
  //       const ipData = await ipResponse.json();
  //       userIp = ipData.ip;
  //     } catch (error) {
  //       console.error("Error fetching IP address:", error);
  //     }

  //     const newDocData = {
  //       admin_id: profileDetails?.uid,
  //       company_id: companyId,
  //       created_date: currentTime,
  //       member_type: "employee",
  //       name: `${profileDetails?.first_name} ${profileDetails?.last_name}`,
  //       time_in: currentTime,
  //       time_out: "",
  //       checkin_location: {},
  //       uid: profileDetails?.uid,
  //       ip_address: userIp,
  //     };

  //     if (roleDetails?.company_admin) {
  //       await addDoc(attendanceHistoryRef, newDocData);
  //       setIsCheckedIn(true);
  //       showNotification({
  //         title: "Check-in Successful",
  //         message: "You have successfully checked in!",
  //         color: "green",
  //       });
  //       setLoading(false);
  //       return;
  //     }

  //     const settingsRef = doc(
  //       db,
  //       "companyprofile",
  //       companyId,
  //       "companysettings",
  //       "attendancesettings"
  //     );
  //     const settingsSnap = await getDoc(settingsRef);
  //     if (!settingsSnap.exists()) {
  //       await addDoc(attendanceHistoryRef, newDocData);
  //       setIsCheckedIn(true);
  //       showNotification({
  //         title: "Check-in Successful",
  //         message: "You have successfully checked in!",
  //         color: "green",
  //       });
  //       setLoading(false);
  //       return;
  //     }

  //     const attendanceSettings = settingsSnap.data();
  //     if (attendanceSettings?.staff_attendance_enabled) {
  //       const availableOptions =
  //         attendanceSettings?.staff_available_options || [];

  //       if (availableOptions.includes("manual_ip")) {
  //         const ipRef = doc(
  //           db,
  //           "companyprofile",
  //           companyId,
  //           "companysettings",
  //           "checkinrestriction"
  //         );
  //         const ipSnap = await getDoc(ipRef);
  //         if (ipSnap.exists()) {
  //           const { from_ip, to_ip } = ipSnap.data();
  //           if (!(userIp >= from_ip && userIp <= to_ip)) {
  //             showNotification({
  //               title: "Error",
  //               message: "Your IP address is not allowed for check-in.",
  //               color: "red",
  //             });
  //             setLoading(false);
  //             return;
  //           }
  //         }
  //       }

  //       if (availableOptions.includes("remote_checkin")) {
  //         if (!navigator.geolocation) {
  //           showNotification({
  //             title: "Error",
  //             message: "Geolocation is not supported by your browser.",
  //             color: "red",
  //           });
  //           setLoading(false);
  //           return;
  //         }

  //         navigator.geolocation.getCurrentPosition(
  //           async ({ coords: { latitude, longitude } }) => {
  //             const geoRef = doc(
  //               db,
  //               "companyprofile",
  //               companyId,
  //               "companysettings",
  //               "georestriction"
  //             );
  //             const geoSnap = await getDoc(geoRef);
  //             if (geoSnap.exists()) {
  //               const { latitude_longitude, radius } = geoSnap.data();
  //               const distance = getDistanceFromLatLonInKm(
  //                 latitude,
  //                 longitude,
  //                 latitude_longitude.lat,
  //                 latitude_longitude.lng
  //               );
  //               if (distance > radius) {
  //                 showNotification({
  //                   title: "Error",
  //                   message: "You are outside the allowed check-in location.",
  //                   color: "red",
  //                 });
  //                 setLoading(false);
  //                 return;
  //               }
  //             }
  //             newDocData.checkin_location = { latitude, longitude };
  //             await addDoc(attendanceHistoryRef, newDocData);
  //             setIsCheckedIn(true);
  //             showNotification({
  //               title: "Check-in Successful",
  //               message: "You have successfully checked in!",
  //               color: "green",
  //             });
  //             setLoading(false);
  //           },
  //           (error) => {
  //             console.error("Geolocation error:", error);
  //             showNotification({
  //               title: "Error",
  //               message: "Unable to retrieve location.",
  //               color: "red",

  //             });
  //             setLoading(false);
  //           }
  //         );
  //         return;
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error during check-in:", error);
  //     showNotification({
  //       title: "Error",
  //       message: "Check-in failed. Please try again later.",
  //       color: "red",
  //     });
  //     logError(error, "handleCheckIn");
  //     setLoading(false);
  //   }
  // };
  const handleCheckIn = async () => {
    if (!companyId || !profileDetails?.uid) {
      console.error("Missing companyId or profileDetails");
      return;
    }

    setLoading(true);

    try {
      let userIp = "";
      try {
        const ipRes = await fetch("https://api64.ipify.org?format=json");
        const ipJson = await ipRes.json();
        userIp = ipJson.ip;
      } catch { }

      const locationPromise = new Promise<{ latitude: number; longitude: number } | null>(
        (resolve) => {
          if (!navigator.geolocation) return resolve(null);
          navigator.geolocation.getCurrentPosition(
            ({ coords }) =>
              resolve({ latitude: coords.latitude, longitude: coords.longitude }),
            () => resolve(null)
          );
        }
      );

      const location = await locationPromise;

      const checkInFunc = httpsCallable(getfunctionlocation, "staffCheckIn");
      const response = await checkInFunc({
        companyId,
        uid: profileDetails.uid,
        latitude: location?.latitude,
        longitude: location?.longitude,
        ipAddress: userIp,
        firstName: profileDetails.first_name,
        lastName: profileDetails.last_name,
        isCompanyAdmin: roleDetails?.company_admin,
      });

      const data = response.data as any;

      if (data.success) {
        setIsCheckedIn(true);
        showToast.success("checkedInSuccessfully");
      } else {
        toast.warn(data.message || "checkinFailed");
      }
    } catch (err) {
      console.error("Check-in error", err);
      logError(err, "handleCheckIn");
      showToast.error("checkinFailed");
    } finally {
      setLoading(false);
    }
  };

  const handleCheckOut = async () => {
    setLoading(true);
    try {
      const locationPromise = new Promise<{ latitude: number; longitude: number } | null>(
        (resolve) => {
          if (!navigator.geolocation) return resolve(null);
          navigator.geolocation.getCurrentPosition(
            ({ coords }) =>
              resolve({ latitude: coords.latitude, longitude: coords.longitude }),
            () => resolve(null)
          );
        }
      );

      const location = await locationPromise;

      const checkOutFunc = httpsCallable(getfunctionlocation, "staffCheckOut");
      const response = await checkOutFunc({
        companyId,
        uid: profileDetails.uid,
        latitude: location?.latitude,
        longitude: location?.longitude,
      });

      const data = response.data as any;

      if (data.success) {
        setIsCheckedIn(false);
        showToast.success("checkedOutSuccessfully");
      } else {
        showToast.error(data.message || "checkoutFailed");
      }
    } catch (error) {
      console.error("Error updating check-out records:", error);
      logError(error, "handleCheckOut");
      showToast.error("checkoutFailed");
    } finally {
      setLoading(false);
    }
  };

  const checkAdminCheckin = async () => {
    try {
      const now = new Date();
      const midnight = new Date(now.setHours(0, 0, 0, 0));
      const midnightTimestamp = Timestamp.fromDate(midnight);

      // Define Firestore collection reference and query
      const attendanceHistoryRef = collection(db, "attendancehistory");
      const attendanceQuery = query(
        attendanceHistoryRef,
        where("company_id", "==", companyId),
        where("uid", "==", profileDetails?.uid),
        where("member_type", "==", "employee"),
        where("time_in", ">=", midnightTimestamp),
        where("time_out", "==", "")
      );

      // Execute the query and check if any active check-ins exist
      const attendanceSnapshot = await getDocs(attendanceQuery);

      if (attendanceSnapshot.empty) {
        // console.log("No active check-in records found for today.");
        setIsCheckedIn(false);
      } else {
        setIsCheckedIn(true);
      }
    } catch (error) {
      console.error("Error checking check-in status:", error);
      logError(error, "checkAdminCheckin SimpleRemoteCheckFeature");
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <LoadingOverlay visible={loading} />
      {!isCheckedIn ? (
        <Button onClick={handleCheckIn} variant="outline">
          Check In
        </Button>
      ) : (
        <Button onClick={handleCheckOut} variant="outline">
          Check Out
        </Button>
      )}
    </div>
  );
};

export default SimpleRemoteCheckFeature;
